
import React, { useState, useEffect } from 'react';
import { TfiLinkedin, TfiGithub, TfiEmail } from "react-icons/tfi";
import { FaTwitter } from "react-icons/fa6";
import { FiCoffee } from "react-icons/fi";

const Hero = () => {
    const skills = [
        { name: "React", color: "#e0218a" },
        { name: "JS", color: "#ff9900" },
        { name: "Tailwind", color: "#e0218a" },
        { name: "AWS", color: "#ff9900" },
        { name: "HTML", color: "#e0218a" },
        { name: "CSS", color: "#ff9900" },
        { name: "Git", color: "#e0218a" },
        { name: "Figma", color: "#ff9900" }
    ];

    const [rotation, setRotation] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setRotation(prev => (prev + 0.5) % 360);
        }, 50);
        return () => clearInterval(interval);
    }, []);

    return (
        <section id="home" className="w-full min-h-screen relative overflow-hidden bg-gradient-to-br from-background to-[#fff8cfb7]/30 pt-24 flex items-center">

            {/* Background Blob */}
            <div className="absolute top-[-10%] left-[-10%] w-[50vw] h-[50vw] bg-nudeBlush rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob"></div>

            <div className="max-w-7xl mx-auto w-full px-8 md:max-w-7xl flex flex-col md:flex-row items-center justify-between relative z-10">
                {/* Left Content */}
                <div className="flex-1 text-center md:text-left space-y-6">
                    <p className="text-muted-foreground text-lg 3xl:text-2xl font-medium">
                        Hi there! My name is
                    </p>
                    <h1 className="text-5xl md:text-7xl 3xl:text-9xl font-bold text-foreground">
                        Amelia<span className="text-primary">.</span>
                    </h1>
                    <p className="text-xl md:text-2xl 3xl:text-4xl text-muted-foreground">
                        Software Engineer
                    </p>
                    <p className="text-muted-foreground text-lg 3xl:text-2xl leading-relaxed max-w-lg 3xl:max-w-2xl mx-auto md:mx-0">
                        Helping businesses establish a strong online presence through modern websites with{" "}
                        <span className="text-primary font-medium">React</span>,{" "}
                        <span className="text-primary font-medium">JavaScript/TypeScript</span>, and
                        modern web technologies.
                    </p>

                    <div className="flex flex-wrap gap-4 justify-center md:justify-start">
                        <a href="https://grabtime.me/book/ameliadutta/coffee-chat-with-amelia" target="_blank" rel="noreferrer"
                            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-crimson text-white font-bold shadow-lg hover:shadow-xl hover:bg-opacity-90 transition-all duration-300 transform hover:-translate-y-1">
                            <FiCoffee size={20} /> Let's Chat
                        </a>
                        <a href="mailto:amelia.dutta.02@gmail.com"
                            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white text-active border-2 border-transparent hover:border-crimson hover:text-crimson font-bold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                            <TfiEmail size={20} /> Mail Me
                        </a>
                    </div>
                </div>

                {/* Right Content - Avatar with orbiting skills */}
                <div className="flex-1 flex flex-col items-center justify-center relative mt-20 md:mt-0">
                    <div className="relative flex justify-center lg:justify-end animate-fade-in">
                        <div className="relative flex flex-col items-center">
                            {/* Orbital container */}
                            <div className="relative w-[320px] h-[320px] md:w-[420px] md:h-[420px] 3xl:w-[600px] 3xl:h-[600px] flex items-center justify-center">
                                {/* Orbital rings */}
                                <div className="absolute w-[280px] h-[280px] md:w-[380px] md:h-[380px] 3xl:w-[540px] 3xl:h-[540px] rounded-full border border-primary/15" />
                                <div className="absolute w-[220px] h-[220px] md:w-[300px] md:h-[300px] 3xl:w-[440px] 3xl:h-[440px] rounded-full border border-primary/10" />

                                {/* Center Avatar/Sprite */}
                                <img
                                    src={require("../images/sprite.png")}
                                    alt="Amelia Sprite"
                                    className="relative -top-4 z-40 w-[200px] h-[200px] md:w-[350px] md:h-[350px] 3xl:w-[500px] 3xl:h-[500px] object-contain drop-shadow-2xl hover:scale-105 transition-transform duration-500"
                                />

                                {/* Orbiting skills */}
                                {skills.map((skill, index) => {
                                    const angle = (index * (360 / skills.length) + rotation) * (Math.PI / 180);
                                    const radius = index % 2 === 0 ? 110 : 150;
                                    const mdRadius = index % 2 === 0 ? 150 : 190;
                                    const lgRadius = index % 2 === 0 ? 220 : 280;
                                    const windowWidth = typeof window !== 'undefined' ? window.innerWidth : 1200;
                                    const is3xl = windowWidth >= 2560;
                                    const isMd = windowWidth >= 768;
                                    const r = is3xl ? lgRadius : (isMd ? mdRadius : radius);
                                    const x = Math.cos(angle) * r;
                                    const y = Math.sin(angle) * r;

                                    return (
                                        <div
                                            key={skill.name}
                                            className="absolute transition-transform duration-75 ease-linear z-20"
                                            style={{ transform: `translate(${x}px, ${y}px)` }}
                                        >
                                            <div className="relative group cursor-pointer">
                                                <div
                                                    className="absolute inset-0 rounded-full blur-md opacity-40 group-hover:opacity-70 transition-opacity"
                                                    style={{ backgroundColor: skill.color }}
                                                />
                                                <div className="relative px-2.5 py-1 md:px-3 md:py-1.5 rounded-full bg-card/95 backdrop-blur-sm border border-primary/30 shadow-sm group-hover:border-primary group-hover:shadow-glow transition-all duration-300 group-hover:scale-110">
                                                    <span className="text-foreground font-medium text-[10px] md:text-xs whitespace-nowrap">
                                                        {skill.name}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}

                                {/* Particles */}
                                {[...Array(6)].map((_, i) => {
                                    const angle = (i * 60 + rotation * 2) * (Math.PI / 180);
                                    const radius = 70 + (i % 2) * 40;
                                    return (
                                        <div
                                            key={i}
                                            className="absolute w-1 h-1 rounded-full bg-primary/40 z-0"
                                            style={{ transform: `translate(${Math.cos(angle) * radius}px, ${Math.sin(angle) * radius}px)` }}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                    {/* Social Handles - Positioned below */}
                    <div className="relative -top-36 md:-top-44 z-30 bg-white/40 backdrop-blur-md border border-white/60 p-4 rounded-2xl shadow-xl flex justify-center items-center md:gap-4 gap-2 w-24 h-12 md:w-max animate-fade-in-up ring ring-4 ring-crimson/30 outline outline-8 outline-offset-2 outline-crimson/30 outline-solid ">
                        <a href="https://www.linkedin.com/in/ameliadutta/" target="_blank" rel="noreferrer"
                            className="text-active hover:text-crimson transition-colors transform hover:scale-110">
                            <TfiLinkedin size={24} />
                        </a>
                        <a href="https://github.com/amelia2802" target="_blank" rel="noreferrer"
                            className="text-active hover:text-crimson transition-colors transform hover:scale-110">
                            <TfiGithub size={24} />
                        </a>
                        <a href="https://twitter.com/AmeliaDutta" target="_blank" rel="noreferrer"
                            className="text-active hover:text-crimson transition-colors transform hover:scale-110">
                            <FaTwitter size={24} />
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
